import * as moment from 'moment';

export interface defaultI { 
error?: string | undefined;
status?: string | undefined;
}

export interface scheduleOrganizationI { 
    dayOfWeek: number;
    periodStart: any;   
    periodEnd?: any;
}

interface Telecom {
    system: 'phone' | 'mobile' | 'email' | 'url',
    use: string,
    value: string
}


class identifier {
    system: 'CNPJ' | 'CPF' | 'CRM';
    value: string;
    constructor(system: 'CNPJ' | 'CPF' | 'CRM', value: string) {
      this.system = system;
      this.value = value;
    }
  
}

export interface organizationI extends defaultI  { 
    organization_id?: number | string | null;
    id: number | string | null;
    name: string; 
    alias: string;
    legal_representative: string;
    active: Boolean;
    token_id: string | null;
    photo? :string;

}

export interface OrganizationInterface  { 
    organization_id: string;
    name: string; 
    alias: string;
    cnpj: string;
    legal_representative: string;
    active: Boolean;
    token_id: string 
    photo? :string;
    modifiedDays?: any[];
}

export interface OrganizationAPIResponse extends defaultI  { 
    organization_id:  string ;
    identifier: identifier[],
    name: string; 
    alias: string;
    legal_representative: string;
    active: Boolean;
    token_id: string
    photo?: string;
    modifiedDays?: any[];
}

export const organizatioInitialState: any =  {
    id: null,
    name: '',
    legal_representative: '',
    identifier: [],
    alias: '',
    active: true,
    specialty: '',
    cnpj: '',
    mobile: '',
    phone: '',
    mail: '',
    contact: [],
    address: {cep: '' },
    schedule: [{ 
        dayOfWeek: moment().isoWeekday(), 
        timeStart: moment().format('HH:mm'), 
        timeEnd: moment().add(30, 'minutes').format('HH:mm')
    }],
    status: 'idle',
    error: undefined
}


export const organizationKeys = Object.keys(organizatioInitialState);